import { FileUp } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconFileUp(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <FileUp />
    </IconWrapper>
  );
}
